import React from 'react';
import { connect } from 'react-redux';

import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { filterPartnerOnFirstLetter } from '../../../services/filter/actions';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { withTemplate } from '../../template/withTemplate';
import { HeadComponent } from '../../HeadComponent';
import DirectoryPage from './DirectoryPage';

// extract the letter from the url params
const extractLetter = (currentProps, nextProps) => {
    const letter = (currentProps && currentProps.match.params.letter) || null;
    const nextLetter = (nextProps && nextProps.match.params.letter) || null;

    return { letter, nextLetter };
};

export class LetterDirectoryPage extends React.Component {
    extractLetterAndDispatch(currentProps, nextProps) {
        const { letter, nextLetter } = extractLetter(currentProps, nextProps);

        if (nextLetter && nextLetter !== letter) {
            this.props.filterPartnerOnFirstLetter(PAGE_DIRECTORY, nextLetter);
        }
    }

    componentDidMount() {
        this.extractLetterAndDispatch(null, this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.extractLetterAndDispatch(this.props, nextProps);
    }

    render() {
        const { match, isCodePromo, i18nPage } = this.props;
        return (
            <div>
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={match.url}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <DirectoryPage letter={match.params.letter || ''} isCodePromo={isCodePromo} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.A_Z
    };
};

const mapDispatchToProps = {
    filterPartnerOnFirstLetter
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(LetterDirectoryPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/LetterDirectoryPage.js